import React from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography } from './../../../themes/default';
import { List, ListItem, ListItemText } from './../../../themes/list';
import { Modal } from './../../../components/includes/modal';

const styles = theme => ({

});

class Notifications extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      notifications: []
    };
  }

  componentDidMount() {
    this._Find(this.props.Notifications);
  }

  componentWillReceiveProps(next_props){
    if(next_props.Notifications !== this.props.Notifications){
      this._Find(next_props.Notifications);
    }
  }

  /*
  ** @Service
  ** @Description: Find
  */

  _Find = (notifications) => {

    // @State
    this.setState({
      notifications: notifications.list
    });

    // @Event
    this.props.onMount({
      total: notifications.list.length
    });

  }

  /*
  ** @Click
  ** @Description: Cancel modal Notifications
  */

  handleClose = () => {
    this.props.onCancel();
  }

  render(){

    const { notifications } = this.state;
    const { open } = this.props;

    return(
      <Modal
        status={ open }
        title="Notificaciones"
        maxWidth="sm"
        handleCancel={ this.handleClose }>

        { notifications.length > 0 ? (

          <List>
            { notifications.map((entity, index) => {
              return (
                <ListItem disableGutters key={ index }>
                  <ListItemText
                    primary={ entity.title }
                    secondary={ entity.description }
                  />
                </ListItem>
              )
            })}
          </List>

        ) : (

          <Typography>No se encontraron resultados.</Typography>

        )}

      </Modal>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    Notifications: state.Notifications
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Notifications));
